LS.api = {
	/**
	 * Make API request
	 *
	 * @param {String} path
	 * @param {Object} [options]
	 * @returns {Object}
	 */
	request(path, options) {
		const scope = this;

		if (! path.startsWith('/')) {
			path = '/' + path;
		}

		options.url = path;

		const fn = () => $.fetch.request(scope.extend(options));

		if (options.guard === false || ! path.startsWith('/me')) {
			return fn();
		}

		LS.user.guard(fn);
	},

	/**
	 * Make API get request
	 *
	 * @param {String} path
	 * @param {Object} [options]
	 * @returns {Object}
	 */
	get(path, options) {
		return this.request(path, Object.assign({
			method: 'get'
		}, options));
	},

	/**
	 * Make API post request
	 *
	 * @param {String} path
	 * @param {Object} [options]
	 * @returns {Object}
	 */
	post(path, options) {
		return this.request(path, Object.assign({
			method: 'post'
		}, options));
	},

	/**
	 * Make API delete request
	 *
	 * @param {String} path
	 * @param {Object} [options]
	 * @returns {Object}
	 */
	delete(path, options) {
		return this.request(path, Object.assign({
			method: 'delete'
		}, options));
	},

	/**
	 * Bind API form submission
	 *
	 * @param {$} el
	 * @param {String} path
	 * @param {Object} [options]
	 */
	bind(el, path, options) {
		const $el = $(el);
		const conf = Object.assign({
			class: 'g-loading',
			shortcut: false,
			validate: true
		}, options);

		if (conf.validate) {
			$el[0].noValidate = true;
		}

		$el.on('submit', () => {
			let data = $el.serialize(true);

			if (typeof conf.data === 'function') {
				data = conf.data(data);

				delete options.data;
			}

			if (conf.validate) {
				if (typeof conf.validate === 'function' && ! conf.validate(data)) {
					return;
				}

				if (! LS.form.validate($el, data, conf.validate)) {
					return;
				}
			}

			$el.addClass(conf.class);

			options = $.extend(true, {
				auth: true,
				method: 'post',
				send: options.send
			}, options);

			options.data = data;

			options.complete = [
				() => {
					$el.removeClass(conf.class);

					if (options.top) {
						LS.util.top();
					}
				},
				options.complete
			];

			LS.api.request(path, options);
		}, {
			namespace: conf.namespace,
			cancel: true
		});
	},

	/**
	 * Extend request options with API context
	 *
	 * @param {Object} options
	 * @returns {Object}
	 */
	extend(options) {
		const conf = $.copy(options);
		const success = conf.success;
		const error = conf.error;
		const headers = {};

		delete conf.success;
		delete conf.error;

		if ((conf.method || 'get') === 'get') {
			headers['Content-Type'] = false;
		}

		if (conf.auth) {
			const token = LS.user.token();

			if (token) {
				headers.authorization = 'Bearer ' + token;
			}
		}

		if (conf.proxy) {
			conf.root = $.get('papiUrl');
		}

		return $.extend(true, {
			namespace: 'api',
			root: $.get('apiUrl'),
			json: true,
			headers: headers,
			success: (data, xhr) => {
				const message = data && data.message ?
					data.message : null;

				if (success) {
					$.exec(success, {
						args: [data, xhr, conf]
					});
				}

				if (message && conf.flash !== false) {
					LS.util.flash(message, 'success');
				}
			},
			error: xhr => {
				const status = xhr.status;

				if (conf.auth && status === 401) {
					LS.user.renew(() => {
						options.error = () => false;

						LS.api.request(options.url, options);
					});

					return;
				}

				const messages = {
					default: 'An error occurred — please try again',
					e0: 'Network error — please try again',
					e404: 'Requested resource can\'t be found'
				};

				const response = xhr.responseText;
				const prompt = conf.prompt;

				let message = messages['e' + status] || messages.default;
				let data = {};

				if (response) {
					try {
						data = JSON.parse(response);

						message = (data.message ?
							data.message : data.errors[0].message
						) || message;
					} catch (e) {
						//
					}
				}

				if (prompt && status === 400) {
					const content = Object.assign({
						confirm: 'Confirm',
						deny: 'Cancel',
						message: message
					}, prompt.content);

					content.force = data.force;

					LS.modal.open({
						model: {
							title: 'Review submission',
							content: $.view.render('modal.prompt', content),
							footer: data.footer ?
								'<p class="g-s-0">' + data.footer + '</p>' : null
						},
						onHide: () => {
							$.events.reset('modalPrompt');
						}
					});

					$.events.on({
						'$modalConfirm': {
							click: () => {
								if (prompt.confirm) {
									prompt.confirm(data);
								}

								LS.modal.close();
							}
						},
						'$modalDeny': {
							click: () => {
								LS.modal.close();

								if (prompt.deny) {
									prompt.deny(data);
								}
							}
						}
					}, {
						namespace: 'modalPrompt'
					});

					return;
				}

				if (error) {
					error(xhr, conf, message);
				}

				if (conf.flash !== false) {
					LS.util.warn(message);
				}

				if (status >= 404 && status !== 422 && status !== 429) {
					LS.log.issue('ApiError', xhr.responseText, {
						status: status,
						url: conf.url
					}, {
						data: conf.data
					});
				}
			}
		}, conf);
	}
};